module.exports = __webpack_public_path__ + "img/landliebe-6368.da386f3f.jpeg";